<template>
  <div class="app-container">
    <Container
      :title="t('company.companyMaster')"
    >
      <template #main>
        <SimpleTable
          :listLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :operateColumnWidth="$hasPermission(['MD_COM_W']) ? 220:80"
        >
          <template
            #default="slotProps"
          >
            <el-button
              v-if="$hasPermission(['MD_COM_W'])"
              @click="handleDetails(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.examine') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted, onActivated } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import Container from '@/components/form/container/Container.vue'
import { CompanyPageParamModel, CompanyTableViewModel } from '@/model/master-data/companyModel'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import { getCompanyPageList } from '@/apis/main-data/company'

export default defineComponent({
  name: 'CompanyPageList',
  components: {
    SimpleTable,
    Container
  },
  setup() {
    const { t } = useI18n()
    const createFormRef = ref()
    const router = useRouter()
    const companyTableStruct = [
      { prop: 'index', label: t('common.indexNumber'), width: 80 },
      { prop: 'name', label: t('company.companyName') },
      { prop: 'companyCode', label: t('company.companyCode'), width: 120 }
    ]
    const dataMap = reactive({
      tableData: Array<CompanyTableViewModel>(),
      columnStruct: companyTableStruct,
      listLoading: true,
      limit: 10,
      total: 0,
      page: 1,
      handleCurrentChange(page?: any) {
        dataMap.getPageList(page)
      },
      handleSizeChange(val: any) {
        dataMap.getPageList(null, val)
      },
      async getPageList(page?: any, limit?: any) {
        if (page) {
          dataMap.page = page
        }
        if (limit) {
          dataMap.limit = limit
        }
        dataMap.listLoading = true
        const params: CompanyPageParamModel = {
          companyCode: null,
          name: null,
          pageCurrent: dataMap.page,
          pageSize: dataMap.limit
        }
        const data = await getCompanyPageList(params)
        if (data && data.data && data.data.list.length > 0) {
          dataMap.tableData = data.data.list.map(
            (item, index) => ({
              id: item.id,
              index: index + 1,
              name: item.name,
              companyCode: item.companyCode
            })
          )
        } else {
          dataMap.tableData = []
        }
        dataMap.total = data?.data.totalCount ?? 0

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    const handleDetails = (row?: CompanyTableViewModel) => {
      if (row) {
        router.push({ path: `details/${row.id}` })
      }
    }
    onMounted(() => {
      dataMap.getPageList(null, 10)
    })
    onActivated(async() => {
      if (history.state?.refresh === true) {
        await dataMap.getPageList()
        // 用完删除
        const state = { ...history.state }
        delete state.refresh
        history.replaceState(state, '')
      }
    })
    return {
      t,
      createFormRef,
      handleDetails,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>

</style>
